import * as Blockly from 'blockly/core';
import 'blockly/python';
import createCustomThresholdFields from "./strata_custom_threshold_fields";
import {getAllowedOutputs} from "./strata_compatibility_checks";
import createInfoButton from './strata_additional_info'

Blockly.Blocks['strata_vuln_indicator'] = {
    init: function () {
        let indicatorInput = this.appendDummyInput()
            .setAlign(Blockly.ALIGN_LEFT)
            .appendField("Vulnerability Indicator   ")
            .appendField(new Blockly.FieldDropdown([
                // ["Population density", "pop_density"],
                ["Population growth", "pop_growth"],
                ["Displacement", "displacement"],
                ["Urban Expansion", "urban_expansion"],
                ["Population ratio of elderly", "elderly"],
                ["Population ratio of children", "children"],
                ["Population ratio of female", "female"],
                ["Travel time to urban area", "time_to_urban"],
                ["Access to Electricity", "access_electricity"],
                ["Sanitation", "sanitation"],
                ["Irrigation", "irrigation"],
                // ["Irrigation", "Irrigation"],
                ["Travel time to healthcare", "access_healthcare"],
                ["Travel time to healthcare (by walking)", "access_healthcare_walking"],
                // ["Disease infection", "disease_infection"],
                // ["Food affordability", "food_affordability"],
                ["Food insecurity", "food_insecurity"],
                // ["Accessibility to school", "Accessibility_to_School"],
            ]), "indicator_selection");
        createInfoButton(indicatorInput, this)
        createCustomThresholdFields(this);

        this.setPreviousStatement(true, 'strata_vulnerability_indicator');
        this.setNextStatement(true, getAllowedOutputs('vulnerability_indicators'));
        this.setStyle('vulnerability_indicator')
        this.setTooltip("");
        this.setHelpUrl("");
    }
}